import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import { Bar } from 'react-chartjs-2';

import theme from 'ui/theme';

const BarChart = ({ config, dataset: info, title, barStyle, height }) => {
  const barRef = useRef();
  const defaultConfig = {
    labels: info?.labels,
    datasets: [
      {
        barPercentage: 0.5,
        barThickness: 20,
        label: title,
        data: [...(info?.data || [])],
        backgroundColor: theme().colors.blue.one,
        borderWidth: 1,
        ...config
      }
    ]
  };

  return (
    <Bar
      ref={barRef}
      data={defaultConfig}
      width={100}
      height={height}
      options={barStyle.options}
    />
  );
};

BarChart.propTypes = {
  config: PropTypes.object,
  dataset: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  title: PropTypes.string,
  height: PropTypes.string,
  barStyle: PropTypes.object
};

BarChart.defaultProps = {
  dataset: [],
  title: ''
};

export default BarChart;
